import { Box } from '@/components/ui/lib/box';
import { Flex } from '@/components/ui/lib/flex';
import { Image } from '@/components/ui/lib/image';
import { Link } from '@/components/ui/lib/link';
import { Text } from '@/components/ui/lib/text';
import { DICTIONARY } from '@/config/dictionary';
import { env } from '@/config/env';
import { APP_PATHS } from '@/config/routes/app-paths';
import { useAppStore } from '@/stores/app-store';
import { ensureValidPath } from '@/utils/validate-path';

const Footer = () => {
  const colorMode = useAppStore((s) => s.colorMode);
  const logoSrc =
    colorMode === 'dark' && env.VITE_LOGO_URL_DARK ? env.VITE_LOGO_URL_DARK : env.VITE_LOGO_URL;

  return (
    <Box
      as="footer"
      padding={5}
      px={{ base: '6', sm: '12' }}
      className="bg-subtle border-t border-rim"
    >
      <Flex
        mx="auto"
        maxW="7xl"
        direction={{ base: 'column', sm: 'row' }}
        align="center"
        justify="space-between"
        gap="4"
      >
        <Link href={ensureValidPath(APP_PATHS.home)} _hover={{ textDecoration: 'none' }}>
          <Image src={logoSrc} alt={DICTIONARY.brand.full} h="7" />
        </Link>
        <Text fontSize="sm" className="text-muted">
          {DICTIONARY.footer.copyright(new Date().getFullYear())}
        </Text>
        <Text as="span" fontSize="xs" className="text-muted">
          v{DICTIONARY.brand.version}
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
